.groupSection {
  margin-bottom: 16px;
}

.groupDescription {
  margin-bottom: 16px;
}

.buttonGroup {
  margin-bottom: 8px;
}

.divider {
  margin-top: 8px;
  margin-bottom: 8px;
}

.optionsGrid {
  margin-bottom: 8px;
  display: flex;
  align-items: flex-end;
}

.formLabel {
  margin-top: 16px;
}

.radioGroup {
  margin-bottom: 8px;
}

.patternInfo {
  margin-bottom: 8px;
}

.fretboardContainer {
  max-height: 300px;
  overflow-y: auto;
}
